// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BuyCard-root-7b57{flex:1 1 auto}`, "",{"version":3,"sources":["webpack://./src/page/tryon/BuyPane/BuyCard.module.scss"],"names":[],"mappings":"AAAA,mBACE,aAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `BuyCard-root-7b57`
};
module.exports = ___CSS_LOADER_EXPORT___;
